import React from 'react';
import { Card } from '../../../components/ui/card';
import { KpiTimeChart } from './KpiTimeChart';
import { CHART_COLORS, fmtNum, fmtNumShort } from './kpiUtils';
import { ColumnasSelector, useColumnas } from './ColumnasSelector';
import { TablaAtencion } from './TablaAtencion';


// B5: top 10 de motivos y tabla completa con columnas por grupo.
export const AtencionMotivos = ({ motivos = {} }) => {
  const filas = motivos.filas || [];
  const grupos = motivos.grupos || [];
  const columnas = [
    { key: 'motivo', label: 'Motivo', fija: true, className: 'text-slate-700' },
    { key: 'total', label: 'Total', right: true, className: 'font-semibold', render: (f) => fmtNum(f.total) },
    ...grupos.map((g) => ({
      key: `g:${g}`, label: g, right: true, className: 'text-slate-600', render: (f) => (f.por_grupo[g] ? fmtNum(f.por_grupo[g]) : '—'),
    })),
  ];
  const cols = useColumnas('motivos', columnas);
  return (
    <div className="mb-6 grid grid-cols-1 gap-6 lg:grid-cols-5" data-testid="atencion-motivos">
      <Card className="p-5 lg:col-span-2 lg:p-6">
        <h2 className="mb-4 text-base font-semibold text-slate-800">Top 10 motivos</h2>
        <KpiTimeChart data={filas.slice(0, 10).map((m) => ({ label: m.motivo, total: m.total }))} xKey="label"
          series={[{ key: 'total', name: 'Tickets', color: '#6366f1' }]} type="barras" barLayout="vertical" cellColors={CHART_COLORS}
          height={Math.max(180, Math.min(10, filas.length) * 34)} valueFormatter={fmtNum} axisFormatter={fmtNumShort} showLegend={false} testId="atencion-motivos-chart" />
      </Card>
      <Card className="p-5 lg:col-span-3 lg:p-6">
        <div className="mb-4 flex items-center gap-2">
          <h2 className="text-base font-semibold text-slate-800">Motivos por grupo <span className="text-xs font-normal text-slate-400">({filas.length})</span></h2>
          <div className="ml-auto"><ColumnasSelector columnas={columnas} estado={cols} testId="atencion-motivos-cols" /></div>
        </div>
        <TablaAtencion columnas={columnas} ver={cols.ver} filas={filas} rowKey={(f) => f.motivo}
          rowTestId={(f, i) => `atencion-motivo-row-${i}`} vacio="Sin tickets en el período." sticky maxH="max-h-[420px]" />
      </Card>
    </div>
  );
};
